
import _ from "lodash";
import React, { useState, useEffect } from "react";

export default function useList(onUpdate) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    console.log('useEffect', items.length, onUpdate);
    if (onUpdate) {
      onUpdate(items);
    }
  }, [items.length]);

  const addItem = (item) => {
    setItems((items) => [...items, item]);
  }

  const deleteItem = (index) => {
    setItems([
      ...items.slice(0, index),
      ...items.slice(index + 1)
    ]);
  }

  const deleteItemByPredicate = (predicate) => {
    const index = _.findIndex(items, predicate);
    if (index !== -1) {
      deleteItem(index)
    }
  }

  return [items, addItem, deleteItem, deleteItemByPredicate];
}
